import { render, staticRenderFns } from "./activityAdd.vue?vue&type=template&id=5b043cf4&scoped=true&"
import script from "./activityAdd.vue?vue&type=script&lang=ts&"
export * from "./activityAdd.vue?vue&type=script&lang=ts&"
import style0 from "./activityAdd.vue?vue&type=style&index=0&id=5b043cf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b043cf4",
  null
  
)

export default component.exports